// react
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

// components
import { SelfReferralFormPage } from '@karehero/llama/pwa/pages/SelfReferralFormPage/SelfReferralFormPage';

// hooks
import { useSelfReferral } from 'hooks/useSelfReferral';
import { useGoBack } from 'hooks/useGoBack';

// router
import { ROUTES } from 'router';

/**
 * SelfReferral wires the SelfReferralFormPage to the self-referral API
 */
export const SelfReferral = () => {
  const navigate = useNavigate();
  const goBack = useGoBack();
  const { handleSelfReferral, isSendingSelfReferral } = useSelfReferral();

  const onSubmit = useCallback(
    async (data: {
      email: string;
      personReceivingCare: string;
      careRecipientFirstName: string;
      careRecipientLastName: string;
    }) => {
      const success = await handleSelfReferral(data.email, '');
      if (success) {
        navigate(ROUTES.PORTAL_SELF_REFERRAL_SENT, { replace: true });
      }
    },
    [handleSelfReferral, navigate],
  );

  return (
    <SelfReferralFormPage
      onBack={goBack}
      onSubmit={onSubmit}
      isSubmitting={isSendingSelfReferral}
    />
  );
};

export default SelfReferral;
